import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IAnswers, SurveyQuestionStructure} from '../survey/survey.component';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {ISurveySelected, ISurveySelectedEvent, SurveyFormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';

@Component({
    selector: 'noos-survey-textarea',
    templateUrl: './survey-textarea.component.html',
    styleUrls: ['./survey-textarea.component.scss']
})
@NoosFormTypeService.register('survey-textarea')
export class SurveyTextareaComponent implements OnInit, AfterViewInit, SurveyFormItemComponentInterface {

    prop: SurveyQuestionStructure;
    isFilter = false;
    thisAppearance: any = 'outline';
    setting: IHttpSetting;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Input()
    index = 0;

    modelText = '';

    answers?: ISurveySelected[];
    isView = false;

    selectedValue: EventEmitter<ISurveySelectedEvent> = new EventEmitter<ISurveySelectedEvent>();
    selectedAnswers: ISurveySelected[] = [];

    constructor() {
    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
    }

    onKeyup($event: KeyboardEvent) {
        this.selectedAnswers = [];
        this.selectedAnswers.push({value: '', title: this.modelText, point: 0});
        this.selectedValue.emit({question: this.prop, answers: this.selectedAnswers});
    }

    getValue() {
        if (this.answers !== undefined && this.answers.length > 0) {
            return this.answers[0].title;
        }
        return '';
    }
}
